// extracted by mini-css-extract-plugin
export var divider = "_25-0";
export var dividerText = "_25-2";
export var dividerVertical = "_25-1";